'use client';
var classes = {"root":"m_a410e613","label":"m_ddb0bfe3"};

export { classes as default };
//# sourceMappingURL=DonutChart.module.css.mjs.map
